export default "__VITE_ASSET__D6z9IXL0__"